import { useLayoutEffect } from 'react';

const PRESENTATION_SNAPSHOT_ATTRIBUTE = 'data-progressive-structural-entry-reveal';

export function hasStructuralEntryRevealIndexMismatch(
  authoritativeEntryIds: readonly string[],
  presentedEntryIds: readonly string[]
): boolean {
  const presentedEntryIdSet = new Set(presentedEntryIds);
  let hasHiddenEntry = false;

  for (const entryId of authoritativeEntryIds) {
    if (!presentedEntryIdSet.has(entryId)) {
      hasHiddenEntry = true;
    } else if (hasHiddenEntry) {
      return true;
    }
  }

  return false;
}

export function useStructuralEntryRevealPresentation({
  isActive,
  layoutRoot
}: {
  isActive: boolean;
  layoutRoot: HTMLElement | null;
}): void {
  useLayoutEffect(() => {
    if (!isActive || !layoutRoot) {
      return;
    }

    const previousInert = layoutRoot.inert === true;
    const previousInertAttribute = layoutRoot.getAttribute('inert');
    const previousPresentationSnapshotAttribute = layoutRoot.getAttribute(
      PRESENTATION_SNAPSHOT_ATTRIBUTE
    );

    layoutRoot.inert = true;
    layoutRoot.setAttribute('inert', '');
    layoutRoot.setAttribute(PRESENTATION_SNAPSHOT_ATTRIBUTE, '');

    return () => {
      layoutRoot.inert = previousInert;

      if (previousInertAttribute === null) {
        layoutRoot.removeAttribute('inert');
      } else {
        layoutRoot.setAttribute('inert', previousInertAttribute);
      }

      if (previousPresentationSnapshotAttribute === null) {
        layoutRoot.removeAttribute(PRESENTATION_SNAPSHOT_ATTRIBUTE);
      } else {
        layoutRoot.setAttribute(
          PRESENTATION_SNAPSHOT_ATTRIBUTE,
          previousPresentationSnapshotAttribute
        );
      }
    };
  }, [isActive, layoutRoot]);
}
